export default __webpack_public_path__ + "images/groupem-high-flag.svg";